<template>
  <div>
    <content-block v-for="(block, index) in blocks" v-if="authorizationList.indexOf(block.identifier) !== -1"
      :key="index" :content="block.content" />
  </div>
</template>

<script>
import { onSSR } from '@vue-storefront/core';
import { useContent } from '~/composables';
import ContentBlock from '../ContentBlock';

export default {
  name: "ContentBlockCustom",
  components: {
    ContentBlock,
  },
  props: {
    identifiers: {
      type: Array,
      default: []
    },
    authorizationList: {
      type: Array,
      default: []
    }
  },
  setup(props) {
    const {
      blocks,
      loadBlocks,
    } = useContent();

    onSSR(async () => {
      await loadBlocks({ identifiers: props.identifiers });
    });

    return {
      blocks,
    };
  },
}
</script>
